import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { connect } from "react-redux";
import * as d from "../../reducers/domainReducer";
import MyChartContainer from "./MyChartContainer";
/*`${window.serverData.data.myChartBaseUrl}app/communication-center/conversation?id=WP-24xDJze9pGAwob3gvx3BZeXg-3D-3D-24kaL7Rbvm03sRbz9iCXSEiEq6LWHfJQ2g8O3guVaot5k-3D`*/
const MessagesAll = (props) => {
 
    useEffect(() => {
        logUI("MBHWeb.UI.MessagesAll.ComponentDidMount", new Date(), Tools.getURLPath());
    }, []);



    const heading = (
        <div className="mychart-btn-container--full-multiple bswh-mychart-overlay">            
            <Link className="btn btn-primary" to={{ pathname: "/letters" }}>
                LETTERS
            </Link>
        </div>);
    const subMode = props.conversationID ? conversation : '';
    return  <MyChartContainer
        title="Messages"
        mode="messages"
        submode={subMode }
        heading={heading}
        key={props.currentUser && props.currentUser.displayName}
        containerClass="message-container"
    />;
       

}

const mapStateToProps = (state) => {
    return {
        currentUser: d.hydrateProxyUser(state.domain.cu),
        isMedicalAdvice: state.memberships.hasAuthorizedFeatureMedicalAdvice
    };
};

export default connect(mapStateToProps, null)(MessagesAll);